import React, { ReactElement } from "react";
import { withRouter } from "react-router";

import WarrantyTable from "./warranty-table";

import { WarrantyContainer, TableDiv } from "./styles";
import {
  LeftDiv,
  HeaderDiv,
  HeadingDiv,
} from "pages/location/styles";

function Warranty(): ReactElement {
  return (
    <WarrantyContainer>
      <HeaderDiv>
        <LeftDiv>
          <HeadingDiv>Warranty</HeadingDiv>
        </LeftDiv>
      </HeaderDiv>
      <TableDiv>
        <WarrantyTable />
      </TableDiv>
    </WarrantyContainer>
  );
}

export default withRouter(Warranty);
